import { render, staticRenderFns } from "./BadgeDesignationDialog.vue?vue&type=template&id=f81c077e"
import script from "./BadgeDesignationDialog.vue?vue&type=script&lang=js"
export * from "./BadgeDesignationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports